<template>
  <div class="ic-input" :class="{ [size]: true, block, plain, disabled }">
    <label class="primary-label" v-if="label !== ''" :for="id">
      {{ label }}
    </label>
    <input
      :id="id"
      :placeholder="placeholder"
      :disabled="disabled"
      :value="formattedValue"
      @input="$emit('input', $event.target.value)"
      @change="change"
      type="number"
      step="0.01"
      v-if="!currency && trade"
    />
    <input
      :id="id"
      :placeholder="placeholder"
      :disabled="disabled"
      :value="formattedValue"
      v-money="moneyOptions"
      @input="$emit('input', $event.target.value)"
      @change="change"
      v-else-if="currency && !trade"
    />
    <input
      @change="change"
      @input="$emit('input', $event.target.value)"
      :id="id"
      :placeholder="placeholder"
      :disabled="disabled"
      :value="value"
      :style="text !== '' ? 'text-align: center': ''"
      type="text"
      v-else
    />
  </div>
</template>

<script>
import { inputProps } from '../../../props'
import { format, unformat } from '../../../plugins/currency-input/utils'
export default {
  props: inputProps,
  data() {
    return {
      formattedValue: '',
      moneyOptions: {
        decimal: this.decimal,
        precision: this.precision,
        thousands: this.thousands,
        prefix: this.prefix,
        suffix: this.suffix,
      },
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          if (this.currency) {
            this.formattedValue = format(newValue, this.moneyOptions)
          }
          this.$emit('input', newValue)
        }
      },
    },
  },
  methods: {
    change(e) {
      this.$emit(
        'change',
        this.currency
          ? unformat(e.target.value, this.moneyOptions.precision)
          : e.target.value
      )
    },
  },
}
</script>

<style lang="scss" src="./IcInput.scss" />
